module.exports = __webpack_public_path__ + "img/media.e9768458.svg";